import { W as WuiStatus$1, d as defineCustomElement$1 } from './p-C4juph28.js';

const WuiStatus = WuiStatus$1;
const defineCustomElement = defineCustomElement$1;

export { WuiStatus, defineCustomElement };
